import { NgModule } from '@angular/core';
import { BetaFeaturesService } from '@app/modules/context/beta-features/beta-features-service';

@NgModule({
	providers: [
		BetaFeaturesService
	],
})
export class ContextModule {}
